import { Loader } from 'shared';
import Box from 'shared_DEPRECATED/components/Box';

type VideoProcessingOrLoadingProps = {
  children?: React.ReactNode;
  borderRadius: string;
};

export const VideoProcessingOrLoading = ({
  children,
  borderRadius,
}: VideoProcessingOrLoadingProps) => (
  <Box
    style={{
      position: 'absolute',
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.3)',
      backdropFilter: 'blur(10px)',
      borderRadius,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 10,
    }}
  >
    <Box style={{ height: '20%' }}>
      <Loader color="var(--white)" />
    </Box>
    {children}
  </Box>
);
